// extracted by mini-css-extract-plugin
export var activityContainer = "_n6-0";
export var typingIndicatorContainer = "_n6-1";
export var typingIndicatorDot = "_n6-2";
export var wave = "_n6-3";